import { render, staticRenderFns } from "./VoegTekenaarToeModal.vue?vue&type=template&id=76960221&scoped=true&"
import script from "./VoegTekenaarToeModal.vue?vue&type=script&lang=js&"
export * from "./VoegTekenaarToeModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./VoegTekenaarToeModal.vue?vue&type=style&index=1&id=76960221&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76960221",
  null
  
)

export default component.exports